import * as React from 'react';
import * as ReactDOM from 'react-dom';
import DatePicker from 'react-datepicker';
import * as moment from 'moment';
import { FormControl } from 'react-bootstrap';

const DATE_FORMAT = 'DD/MM/YYYY';

class Input extends React.Component {
  private element;

  public focus = () => {
    const node: any = ReactDOM.findDOMNode(this.element);

    node.focus();
  }

  private setElementFromRef = (element) => {
    this.element = element;
  }

  public render() {
    return (
      <FormControl {...this.props} ref={this.setElementFromRef}/>
    );
  }
}

const AlternativeDatePicker = ({
                                 input = {},
                                 // change,
                                 placeholder = '',
                                 showYear = true,
                                 showMonth = true,
                                 meta = {},
                                 ...props }) => {
  const handleChange = (date) => {
    const momentDate = moment(date);

    input.onChange(momentDate.isValid() ? momentDate.format(DATE_FORMAT) : '');
  };

  return (
    <div className={meta.touched && meta.error ? 'has-error' : ''}>
      <div className="icon-cal">
        <DatePicker
          {...input}
          {...props}
          locale="en-gb"
          customInput={<img src={require('./image/calendar_white.svg')}/>}
          placeholder={placeholder}
          dateFormat={DATE_FORMAT}
          selected={input.value ? moment(input.value, DATE_FORMAT) : null}
          onChange={handleChange}
          showYearDropdown={showYear}
          showMonthDropdown={showMonth}
          dropdownMode="select"
          disabledKeyboardNavigation={false}
        />
      </div>
      {/*{touched && error && <HelpBlock>{error}</HelpBlock>}*/}
    </div>
  );
};

export default AlternativeDatePicker;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/components/AlternativeDatePicker/index.tsx